import { Component, Input } from '@angular/core';
import { Report } from '../../models/Report';
import { ModalController } from 'ionic-angular';
import { AddReportComponent } from '../add-report/add-report';

@Component({
    selector: 'report-view',
    templateUrl: 'report-view.html'
})
export class ReportViewComponent {

    @Input('report') report: Report;
    @Input('withCard') withCard: boolean;

    constructor(public modalCtrl: ModalController) {
    }

    openReport() {
        let modal = this.modalCtrl.create(AddReportComponent, { report: this.report });
        modal.present();
    }

}



// WEBPACK FOOTER //
// ./src/components/report-view/report-view.ts